import { useHistory } from 'react-router-dom';
import EventCard from '../../Calendar/MonthSection/EventCard/EventCard';
import ErrorState from 'common/ErrorState/ErrorState';
import { useRevealGroup } from 'hooks/useReveal';
import { useCalendar } from 'hooks/useCalendar';
import Loader from 'components/Loader/Loader';
import Button from 'common/Button/Button';
import './NearestEvents.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Найближчі заходи — ADR-0006.
 *
 * Прибрано: заголовок, продубльований шість разів і пущений нескінченним рядком;
 * порожній <Swiper> із закоментованим вмістом, який усе одно рендерився в DOM.
 * На вузьких екранах сітка згортається в одну колонку.
 *
 * Збій запиту лишається всередині секції: решта головної працює як звичайно.
 */
export default function NearestEvents() {
  const language = useLanguage();
  const { data: events, status, error, retry, isLoading } = useCalendar();
  const { push } = useHistory();
  const gridRef = useRevealGroup('.event-card', {}, status);

  // Було: лише заходи з організацією «СГОСТУ» — свіже змагання з e-phan без
  // ручної доповнення в CMS сюди не потрапляло. Стало: перші чотири найближчі
  // заходи без відбору за організатором. useCalendar уже віддає перелік
  // відсортованим за датою початку (mergeEvents), тож перші чотири — і є
  // найближчі.
  const nearestEvents = events.slice(0, 4);

  return (
    <section className='nearest-events section section--sunken'>
      <div className='container'>
        <div className='section-head section-head--split'>
          <h2 className='section-title'>{language === 'en' ? 'Upcoming events' : 'Найближчі заходи'}</h2>
          <Button
            variant='link'
            buttonText={language === 'en' ? 'All calendar' : 'Увесь календар'}
            onClick={() => push('/calendar')}
          />
        </div>

        {isLoading && <Loader />}

        {status === 'failed' && <ErrorState error={error} onRetry={retry} />}

        {status === 'succeeded' &&
          (nearestEvents.length > 0 ? (
            <div className='events-grid' ref={gridRef}>
              {nearestEvents.map((event) => (
                <EventCard className='nearest-event-card' event={event} key={event.id} />
              ))}
            </div>
          ) : (
            <p className='empty-note'>
              {language === 'en'
                ? 'There are no upcoming events in the calendar yet.'
                : 'Найближчих заходів у календарі поки немає.'}
            </p>
          ))}
      </div>
    </section>
  );
}
